<template>
  <div class="public-panel">
    <img src="@/assets/images/header-logo-white.svg" />

    <div class="form">
      <h4 class="title">Change Password</h4>

      <md-field :class="{'input-error': $v.password.$error}">
        <label>Password</label>
        <md-input v-model="password" type="password" @blur="$v.password.$touch()" />
      </md-field>
      <h6 class="error-message" v-if="$v.password.$error">Please enter the Password with atleast {{$v.password.$params.minLength.min}} characters</h6>

      <md-field :class="{'input-error': $v.confirmPassword.$error}">
        <label>Confirm Password</label>
        <md-input v-model="confirmPassword" type="password" @blur="$v.confirmPassword.$touch()"
                  @keyup.enter="resetPassword" />
      </md-field>
      <h6 class="error-message" v-if="$v.confirmPassword.$error && !$v.confirmPassword.required">Please enter the Password again</h6>
      <h6 class="error-message" v-else-if="$v.confirmPassword.$error && !$v.confirmPassword.sameAs">The Confirm Password does not match</h6>

      <button @click="resetPassword">Update Password</button>
    </div>
  </div>
</template>

<script>
import ApiServices from '@/services/api/sessions'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'ResetPassword',
  data () {
    return {
      token: null,
      password: null,
      confirmPassword: null
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(8)
    },
    confirmPassword: {
      required,
      sameAs: sameAs('password')
    }
  },
  created () {
    this.token = this.$route.params.token
    this.verifyLink()
  },
  methods: {
    verifyLink () {
      ApiServices.verifyResetLink({token: this.token}).catch(() => {
        this.$router.push({name: 'Login'})
      })
    },
    resetPassword () {
      this.$v.$touch()
      if (!this.$v.$error) {
        let params = {
          password: this.password,
          confirm_password: this.confirmPassword,
          token: this.token
        }

        ApiServices.resetPassword(params).then((response) => {
          this.successToastMsg(response.message)
          this.$router.push({name: 'Login'})
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/publicPanel.scss';
</style>
